import { fetch } from "../lib/network";
import decamelizeKeys from "decamelize-keys";
import AppSettings from "../config";
import { coreService } from "../services/coreService";
import { buildQuery } from "../lib/network";

export const getGeneralSettings = (headers: any) => () => {
  return buildQuery(coreService.agencySettingsGeneralSettingsList({ headers }), (response) => {
    return response.data;
  });
};

export const getGeneralSetting = (networkHeaders: any, name: string) => () =>
  fetch(`${AppSettings.ADMIN_API_URL}/general/${name}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const putGeneralSettings = (headers: any) => (data: { sealFileId?: string; country?: string }) => {
  return buildQuery(coreService.agencySettingsGeneralSettingsUpdate(data, { headers }), (response) => {
    return response.data;
  });
};

export const getPermitsSettings = (networkHeaders: any) => () =>
  fetch(`${AppSettings.ADMIN_API_URL}/permits`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const putPermitsSettings = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.ADMIN_API_URL}/permits`, {
    method: "PUT",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: decamelizeKeys(body, "-") } }),
  });

export const getBoundarySettings = (networkHeaders: any) => () =>
  fetch(`${AppSettings.ADMIN_API_URL}/crm/boundary`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const putBoundarySettings = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.ADMIN_API_URL}/crm/boundary`, {
    method: "PUT",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: decamelizeKeys(body, "-") } }),
  });

export const deleteBoundarySettings = (networkHeaders: any) => () =>
  fetch(`${AppSettings.ADMIN_API_URL}/crm/boundary`, {
    method: "DELETE",
    headers: networkHeaders,
  }).then((res) => res.json());

export const getCountries = () => {
  return buildQuery(coreService.countriesList(), (response) => {
    return response.data;
  });
};

export const getCountrySetting = (headers: any) => () => {
  return buildQuery(coreService.agencySettingsCountryList({ headers }), (response) => {
    return response.data;
  });
};
